import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { dotFormatter, formatDate } from '../../../../../../../helpers';
import { useStore, useTranslation } from '../../../../../../../hooks';
import { JackpotTierName } from '../../../../../../../enums';
import { T } from '../../../../../../../constants';

interface JackpotTierWinnerProps {
  date?: string;
  title: string;
  symbol?: string;
  secretId?: string;
  gameName?: string;
  winAmount?: number;
  tierName: JackpotTierName;
}

export const JackpotTierWinner: React.FC<JackpotTierWinnerProps> = observer(({
  date,
  title,
  symbol,
  secretId,
  gameName,
  tierName,
  winAmount
}) => {

  const t = useTranslation();
  const { gameStore } = useStore();
  const { currencyCode } = gameStore;

  const formatedDate = useMemo(() => {
    return date ? formatDate(new Date(date)) : '-';
  }, [date]);

  return (
    <div className="jackpot-popup-win-bl">
      <div className="jackpot-popup-win-bl-inner">
        <div className="jackpot-popup-win-bl-i">
          <h3 className="jackpot-popup-win-bl-title">{ t(title) }</h3>
          <h4 className="jackpot-popup-win-bl-subtitle">{ gameName || '-' }</h4>
          <p className="jackpot-popup-win-bl-amount">{winAmount ? `${dotFormatter(winAmount, 2)} ${currencyCode}` : '-'}</p>
        </div>
        <div className="jackpot-popup-win-bl-i">
          {
            symbol && (
              <div className="win-type-img-holder">
                <img src={symbol} alt={tierName} />
              </div>
            )
          }
        </div>
      </div>
      <div className="jackpot-popup-win-bl-sub-txt-holder">
        <p className="jackpot-popup-win-bl-sub-txt">{ secretId ? `${t(T.ID)}: ${secretId}` : '' }</p>
        <p className="jackpot-popup-win-bl-sub-txt">{ formatedDate }</p>
      </div>
    </div>
  );
});
